import React from 'react';
import styled from 'styled-components';
import styles from '@repo/ui-components/styles';

const Container = styled.button`
  background: none;
  border-radius: ${styles.spacing['spacing-2xs']};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  border: none;
  width: calc(${styles.spacing['spacing-1xl']});
  height: calc(${styles.spacing['spacing-1xl']});
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${({ theme }) => theme.button.tertiary.backgroundHover};
  }

  svg {
    // fix icon shrinking in flex container on iOS
    flex-shrink: 0;
  }
`;

interface IconButtonProps {
  icon: React.ReactNode;
  onClick?: () => void;
  tabIndex?: number;
  ariaLabelledBy?: string;
  title?: string;
}

// icon button component that takes an SVG file as a prop
function IconButton({
  icon,
  onClick = () => {},
  tabIndex = 0,
  ariaLabelledBy = null,
  title = null,
}: Readonly<IconButtonProps>) {
  return (
    <Container
      type="button"
      tabIndex={tabIndex}
      onClick={onClick}
      aria-label={ariaLabelledBy}
      title={title}
    >
      {icon}
    </Container>
  );
}

export default IconButton;
